import { AddEditBrand as Page } from './AddEditBrand.main';

export const AddEditBrand = { Page };
